<div *ngIf="!showMobileQr; else continueOnMobile">
	<div *ngIf="cafAuthentication$() | async">
		<obg-m-dialog-layout #dialog>
			<account-document-detector-container [useLatestSdk]="isLatestDocSdkEnabled" />
		</obg-m-dialog-layout>
	</div>
</div>
<ng-template #continueOnMobile>
	<obg-m-dialog-layout #dialog>
		<account-continue-on-mobile_qr />
	</obg-m-dialog-layout>
</ng-template>
